<template>
  <b-dropdown
    variant="primary"
    :disabled="!filtered || filtered.length === 0"
    class="mr-2"
    menu-class="small-dropdown a-dropdown-menu"
  >
    <template slot="button-content">
      <i class="far fa-download mr-2"></i>
      <span>Export Results</span>
      <i class="far fa-angle-down ml-2"></i>
    </template>
    <div class="dropdown-header">
      <h6>File Type</h6>
    </div>
    <b-dropdown-item @click="exportTXT()">TXT Document</b-dropdown-item>
    <b-dropdown-item @click="exportCSV()">CSV Document</b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  props: {
    exportProcess: Function,
    filtered: Array,
    filename: String
  },
  methods: {
    exportCSV() {
      const data = this.exportProcess(this.filtered);

      JSONtoCSV(
        data,
        `${this.filename}-${dateToDateString(new Date(), "-")}`,
        true
      );
    },
    exportTXT() {
      const data = this.exportProcess(this.filtered);

      JSONtoTXT(data, `${this.filename}-${dateToDateString(new Date(), "-")}`);
    }
  }
};

function dateToDateString(value, splitter = '/') {
  var result = new Date(value).toDateString('en-AU');

  return result.replace(/\//g, splitter);
}

function generateText(JSONData, ShowLabel) {
  const arrData =
    typeof JSONData !== "object" ? JSON.parse(JSONData) : JSONData;

  const CSV = [];

  // This condition will generate the Label/Header
  if (ShowLabel === true) {
    CSV.push(Object.keys(arrData[0]).join(","));
  }

  arrData.forEach(item => {
    // 2nd loop will extract each column and convert it in string comma-seprated
    const row = Object.values(item).map(x => `"${x}"`);

    // add a line break after each row
    CSV.push(row.join(","));
  });

  return CSV.join("\r\n");
}

function JSONtoCSV(JSONData, ReportTitle, ShowLabel) {
  // If JSONData is not an object then JSON.parse will parse the JSON string in an Object

  const CSV = generateText(JSONData, ShowLabel);

  if (CSV == "") {
    alert("Invalid data");
    return;
  }

  // this will remove the blank-spaces from the title and replace it with an underscore
  const fileName = ReportTitle.replace(/ /g, "_");

  // Initialize file format you want csv or xls
  const uri = `data:text/csv;charset=utf-8,${escape(CSV)}`;

  // Now the little tricky part.
  // you can use either>> window.open(uri);
  // but this will not work in some browsers
  // or you will not get the correct file extension

  // this trick will generate a temp <a /> tag
  const link = document.createElement("a");
  link.href = uri;

  // set the visibility hidden so it will not effect on your web-layout
  link.style = "visibility:hidden";
  link.download = `${fileName}.csv`;

  // this part will append the anchor tag and remove it after automatic click
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function JSONtoTXT(JSONData, fileName) {
  const CSV = generateText(JSONData, false);

  if (!fileName) {
    return CSV;
  }

  const uri = escape(CSV);
  fileName = fileName.replace(/ /g, "_");

  // this trick will generate a temp <a /> tag
  const link = document.createElement("a");
  link.href = `data:text/txt;charset=utf-8,${uri}`;

  // set the visibility hidden so it will not effect on your web-layout
  link.style = "visibility:hidden";
  link.download = `${fileName}.txt`;

  // this part will append the anchor tag and remove it after automatic click
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
</script>
